export default __webpack_public_path__ + "static/media/youWin.506e865d.mp3";